(function () {
  'use strict';

  document.querySelectorAll('.vgp-section').forEach(function (section) {
    initModal(section);
    initCarousels(section);
  });

  /* =========================================================
     MODAL: abrir/cerrar y armar el video (Shopify o YouTube)
     ========================================================= */
  function initModal(section) {
    var modal = section.querySelector('.vgp-modal');
    var mediaBox = modal.querySelector('.vgp-modal-media');
    var closeEls = modal.querySelectorAll('[data-vgp-close]');

    section.querySelectorAll('.vgp-play-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    function openModal(btn) {
      var card = btn.closest('.vgp-card');
      var template = card.querySelector('.vgp-media-template');
      var source = btn.getAttribute('data-source');
      var isMobileCard = card.classList.contains('vgp-card-mobile');

      mediaBox.innerHTML = '';

      if (source === 'youtube') {
        var url = btn.getAttribute('data-youtube') || '';
        var videoId = extractYoutubeId(url);
        if (!videoId) return;

        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        if (isMobileCard) iframe.classList.add('vgp-vertical');
        mediaBox.appendChild(iframe);
      } else if (template) {
        var clone = template.content.cloneNode(true);
        var videoEl = clone.querySelector('video');
        if (videoEl && isMobileCard) videoEl.classList.add('vgp-vertical');
        mediaBox.appendChild(clone);
        var insertedVideo = mediaBox.querySelector('video');
        if (insertedVideo) {
          insertedVideo.play().catch(function () {
            /* autoplay bloqueado por el navegador: el usuario le da play manualmente */
          });
        }
      } else {
        return;
      }

      modal.hidden = false;
      document.body.classList.add('vgp-modal-open');
    }

    function closeModal() {
      modal.hidden = true;
      mediaBox.innerHTML = '';
      document.body.classList.remove('vgp-modal-open');
    }

    function extractYoutubeId(url) {
      var match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      return match ? match[1] : null;
    }
  }

  /* =========================================================
     CAROUSELS: flechas prev/next para desktop (si aplica) y mobile
     ========================================================= */
  function initCarousels(section) {
    // Carousel desktop (solo si el layout elegido es "carousel")
    var desktopTrack = section.querySelector('.vgp-layout-carousel .vgp-track');
    var desktopArrows = section.querySelector('.vgp-desktop-view > .vgp-arrows');
    if (desktopTrack && desktopArrows) {
      wireArrows(desktopTrack, desktopArrows);
    }

    // Carousel mobile (siempre presente)
    var mobileTrack = section.querySelector('.vgp-mobile-track');
    var mobileArrows = section.querySelector('.vgp-arrows-mobile');
    if (mobileTrack && mobileArrows) {
      wireArrows(mobileTrack, mobileArrows);
    }

    function wireArrows(track, arrowsWrap) {
      var prevBtn = arrowsWrap.querySelector('.vgp-arrow-prev');
      var nextBtn = arrowsWrap.querySelector('.vgp-arrow-next');
      if (!prevBtn || !nextBtn) return;

      prevBtn.addEventListener('click', function () {
        scrollByCard(track, -1);
      });
      nextBtn.addEventListener('click', function () {
        scrollByCard(track, 1);
      });
    }

    function scrollByCard(track, direction) {
      var card = track.querySelector('.vgp-card');
      if (!card) return;
      var cardWidth = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap || '0');
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }
  }
})();